const formats = [
  {
    // 01 XX-99-99
    format: /[A-Z]{2}-?[\d]{2}-?[\d]{2}/g,
    separatorPosition1: 2,
    separatorPosition2: 4,
  },
  {
    // 02 99-99-XX
    format: /[\d]{2}-?[\d]{2}-?[A-Z]{2}/g,
    separatorPosition1: 2,
    separatorPosition2: 4,
  },
  {
    // 03 99-XX-99
    format: /[\d]{2}-?[A-Z]{2}-?[\d]{2}/g,
    separatorPosition1: 2,
    separatorPosition2: 4,
  },
  {
    // 04 XX-99-XX
    format: /[A-Z]{2}-?[\d]{2}-?[A-Z]{2}/g,
    separatorPosition1: 2,
    separatorPosition2: 4,
  },
  {
    // 05 XX-XX-99
    format: /[A-Z]{2}-?[A-Z]{2}-?[\d]{2}/g,
    separatorPosition1: 2,
    separatorPosition2: 4,
  },
  {
    // 06 99-XX-XX
    format: /[\d]{2}-?[A-Z]{2}-?[A-Z]{2}/g,
    separatorPosition1: 2,
    separatorPosition2: 4,
  },
  {
    // 07 99-XXX-9
    format: /[\d]{2}-?[A-Z]{3}-?[\d]{1}/g,
    separatorPosition1: 2,
    separatorPosition2: 5,
  },
  {
    // 08 9-XXX-99
    format: /[\d]{1}-?[A-Z]{3}-?[\d]{2}/g,
    separatorPosition1: 1,
    separatorPosition2: 4,
  },
  {
    // 09 XX-999-X
    format: /[A-Z]{2}-?[\d]{3}-?[A-Z]{1}/g,
    separatorPosition1: 2,
    separatorPosition2: 5,
  },
  {
    // 10 X-999-XX
    format: /[A-Z]{1}-?[\d]{3}-?[A-Z]{2}/g,
    separatorPosition1: 1,
    separatorPosition2: 4,
  },
  {
    // 11 XXX-99-X
    format: /[A-Z]{2}-?[\d]{3}-?[A-Z]{1}/g,
    separatorPosition1: 3,
    separatorPosition2: 5,
  },
  {
    // 12 X-99-XXX
    format: /[A-Z]{1}-?[\d]{2}-?[A-Z]{3}/g,
    separatorPosition1: 1,
    separatorPosition2: 3,
  },
  {
    // 13 9-XX-999
    format: /[\d]{1}-?[A-Z]{2}-?[\d]{3}/g,
    separatorPosition1: 1,
    separatorPosition2: 3,
  },
  {
    // 14 999-XX-9
    format: /[\d]{3}-?[A-Z]{2}-?[\d]{1}/g,
    separatorPosition1: 3,
    separatorPosition2: 5,
  },
  {
    // 15 XXX-99-X
    format: /[A-Z]{3}-?[\d]{2}-?[A-Z]{1}/g,
    separatorPosition1: 3,
    separatorPosition2: 5,
  },
]

const getLicensePlateFormat = (value) =>
  formats.find((format) => new RegExp(format.format).test(value.toUpperCase()))

const addSeparators = (value) => {
  const format = getLicensePlateFormat(value)
  if (!format) return value

  const part1 = value.slice(0, format.separatorPosition1)
  const part2 = value.slice(format.separatorPosition1, format.separatorPosition2)
  const part3 = value.slice(format.separatorPosition2, value.length)
  return `${part1}-${part2}-${part3}`
}

export { formats, getLicensePlateFormat, addSeparators }
